(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MuiTreeView", [], factory);
	else if(typeof exports === 'object')
		exports["MuiTreeView"] = factory();
	else
		root["MuiTreeView"] = factory();
})(window, function() {
return 